import { ToastController, LoadingController, Loading, AlertController, Toast } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TotvsNotificationType } from './totvs-notification-type';
import { TotvsNotificationOptions } from './totvs-notification-options';

@Injectable()
export class TotvsNotificationProvider {

    private loading: Loading;
    static readonly SUCCESS: number = 0;
    static readonly ERROR: number = 1;
    static readonly WARNING: number = 2;

    toastDisplay: Toast;

    constructor(public toastCtrl: ToastController,
        public loadingCtrl: LoadingController,
        private _alertController: AlertController,
        private _translate: TranslateService) { }

    async toast(message: string, options?: TotvsNotificationOptions) {

        try {
            await this.toastDisplay.dismiss();
        } catch (e) { }

        options = options || {};
        const showActionButton = options.actionButton ? true : false;
        this.toastDisplay = this.toastCtrl.create({
            message: message,
            duration: options.duration || 5000,
            showCloseButton: showActionButton,
            closeButtonText: options.actionButtonText || this._translate.instant("COMMON.UNDO"),
            cssClass: this.getCssClass(options.type || TotvsNotificationType.INFO)
        });
        this.toastDisplay.present()
            .then(() => {
                if (this.toastDisplay.instance) {
                    this.toastDisplay.instance._elementRef.nativeElement.onclick = (ev) => {
                        if (ev.target.className.indexOf('button') != -1) {
                            options.actionButton();
                            this.toastDisplay.dismiss().catch();
                        } else {
                            this.toastDisplay.dismiss().catch();
                        }
                    };
                }
            });
    }

    private getCssClass(type: TotvsNotificationType) {
        let cssClass;
        switch (type) {
            case TotvsNotificationType.INFO:
                cssClass = 'successToast';
                break;
            case TotvsNotificationType.WARN:
                cssClass = 'avisoToast';
                break;
            case TotvsNotificationType.ERROR:
                cssClass = 'errorToast';
                break;
            default:
                cssClass = 'successToast';
                break;
        }
        return cssClass;
    }

    presentLoading(_enableBackdropDismiss?: boolean) {
        if (this.loading == undefined || this.loading == null) {

            this.loading = this.loadingCtrl.create({
                content: this._translate.instant("TOAST.WAIT"),
                enableBackdropDismiss: _enableBackdropDismiss
            });

            return this.loading.present();
        }
        return this.loading.present();
    }

    dismissLoading() {
        if (this.loading != undefined || this.loading != null) {
            this.loading.dismiss();

            this.loading = null;
        }
    }

    //ALERT
    presentAlert(_title: string, _subTitle: string, _buttons: any[], _enableBackdropDismiss?: boolean) {
        let alert = this._alertController.create({
            title: _title,
            subTitle: _subTitle,
            buttons: _buttons,
            enableBackdropDismiss: _enableBackdropDismiss
        });
        alert.present();
    }

    presentPrompt(_title: string, inputs: any[], _buttons: any[], _subTitle?: string, _enableBackdropDismiss?: boolean) {
        let alert = this._alertController.create({
            title: _title,
            subTitle: _subTitle,
            inputs: inputs,
            buttons: _buttons,
            enableBackdropDismiss: _enableBackdropDismiss
        });
        alert.present();
    }

}

